import axios from 'axios';

export const getPaymentConfig = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/payments/config`);
    return data;
};

export const createRazorpayOrder = async (items) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payments/razorpay/order`, {
        items
    });
    return data;
};

export const verifyRazorpayPayment = async (payment, products, buyer, address, items, contactEmail) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payments/razorpay/verify`, {
        ...payment,
        products,
        items,
        contactEmail,
        buyer,
        address
    });
    return data;
};

// Opens Razorpay checkout for the cart. Resolves with the saved order once the
// server has verified the payment, resolves null if the customer closes the popup,
// and rejects if the payment fails or can't be verified.
export const payWithRazorpay = async ({ cart, user, userId, address, contactEmail }) => {
    const Razorpay = await loadRazorpayScript();
    const order = await createRazorpayOrder(cart.map(item => ({ id: item.id, amount: item.amount })));

    return new Promise((resolve, reject) => {
        const checkout = new Razorpay({
            key: order.keyId,
            order_id: order.orderId,
            amount: order.amount,
            currency: order.currency,
            name: 'Raano',
            description: 'Raano order',
            prefill: {
                name: user ? `${user.firstName} ${user.lastName}` : '',
                email: user?.email || '',
                contact: user?.phone || ''
            },
            notes: { address },
            theme: { color: '#385898' },
            handler: (payment) => {
                verifyRazorpayPayment(payment, cart.map(item => item.id), userId, address, cart.map(item => ({ id: item.id, amount: item.amount, size: item.size })), contactEmail)
                    .then(result => resolve(result.newOrder))
                    .catch(error => reject(new Error(error.response?.data?.error || 'Payment could not be verified.')));
            },
            modal: {
                ondismiss: () => resolve(null)
            }
        });
        checkout.on('payment.failed', (response) => {
            reject(new Error(response.error?.description || 'Payment failed, please try again.'));
        });
        checkout.open();
    });
};

// Loads Razorpay's hosted checkout script once and resolves to window.Razorpay
export const loadRazorpayScript = () => new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Could not load Razorpay checkout.'));
    document.body.appendChild(script);
});
